export default "__VITE_ASSET__BH8GWzst__"